import { SvgIcon } from './svg-icon';
import { ComponentSvgIconProps, SvgIconProps } from './svg-icon.d';
import { mergeProps } from 'solid-js';

const defaultProps: SvgIconProps = {
    viewBox: '0 0 24 24',
    fill: 'currentColor',
    defaultAriaLabel: 'Print Icon',
};

export const PrintCviIcon = (componentProps: ComponentSvgIconProps) => {
    const props = mergeProps(defaultProps, componentProps);

    return (
        <SvgIcon {...props}>
            <path d="M16 8C15.4477 8 15 8.44771 15 9C15 9.55229 15.4477 10 16 10H19C19.5523 10 20 9.55229 20 9C20 8.44771 19.5523 8 19 8H16Z" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C5.44772 0 5 0.447715 5 1V4L2 4C0.89543 4 0 4.89543 0 6V18C0 19.1046 0.895431 20 2 20H5V23C5 23.5523 5.44771 24 6 24H18C18.5523 24 19 23.5523 19 23V20H22C23.1046 20 24 19.1046 24 18V6C24 4.89543 23.1046 4 22 4L19 4V1C19 0.447715 18.5523 0 18 0H6ZM5 14V18H2L2 6L6 6H22V18H19V14C19 13.4477 18.5523 13 18 13L6 13C5.44771 13 5 13.4477 5 14ZM17 4V2H7V4L17 4ZM17 15L7 15L7 22H17V15Z" />
        </SvgIcon>
    );
};
